import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface RolViaItem {
  idRolVia: number;
  descripcionRolVia: string;
  fechaModifica?: string;
  Estado: number;
}

@Injectable({
  providedIn: "root",
})
export class RolViaService {
  private apiUrl = `${environment.apiUrl}/api/rolvia`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<RolViaItem[] | { rolvia?: RolViaItem[]; rolesVia?: RolViaItem[] }> {
    return this.http.get<RolViaItem[] | { rolvia?: RolViaItem[]; rolesVia?: RolViaItem[] }>(this.apiUrl, {
      withCredentials: true,
    });
  }
}
